import PropTypes from "prop-types";
import React from "react";
import Popup from "reactjs-popup";
import CheckoutEmbedSnippet from "./CheckoutEmbedSnippet";
import { ticketWidgetTag, trafficSourceTag } from "./embedSnippets";
import "./checkoutEmbedModal.css";

const contentStyle = {
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "min(960px, calc(100vw - 32px))",
  padding: "0px",
};

const CheckoutEmbedModal = ({
  open,
  onClose,
  iframeId,
  title,
  embedUrl,
  heading = "Embed Ticket widget",
  intro = "Add these two snippets to your website so customers can buy tickets directly.",
  widgetInstructions = "Ticket widget — paste where you want checkout to appear on the event's page.",
  showTrafficTag = true,
  children,
}) => (
  <Popup open={open} contentStyle={contentStyle} closeOnDocumentClick className="popup-modal" onClose={onClose}>
    <div className="popup-modal-container checkout-embed-modal">
      <div className="checkout-embed-header">
        <p className="setlist-text-lg setlist-font-semibold mb-0">{heading}</p>
        <button type="button" className="checkout-embed-close text-muted" aria-label="Close" onClick={onClose}>
          <i className="fal fa-times" />
        </button>
      </div>
      <hr className="m-0 checkout-embed-divider" />
      <div className="checkout-embed-body">
        <p className="setlist-text-md text-dark">
          {intro}
          <br />
          For embedded checkout to work on your site, you must enable HTTPS/TLS.
        </p>

        {children}

        {showTrafficTag && (
          <CheckoutEmbedSnippet
            step={1}
            instructions={<>Traffic-source tag &mdash; add once, inside the &lt;head&gt; of every page of your site.</>}
            rows={2}
            code={trafficSourceTag(embedUrl)}
            copyLabel="Copy Tag"
          />
        )}

        <CheckoutEmbedSnippet
          step={showTrafficTag ? 2 : 1}
          instructions={widgetInstructions}
          rows={6}
          code={ticketWidgetTag(embedUrl, iframeId, title)}
          copyLabel="Copy Code"
        />
      </div>
    </div>
  </Popup>
);

CheckoutEmbedModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  iframeId: PropTypes.string.isRequired,
  title: PropTypes.string,
  embedUrl: PropTypes.string.isRequired,
  heading: PropTypes.string,
  intro: PropTypes.string,
  widgetInstructions: PropTypes.string,
  showTrafficTag: PropTypes.bool,
  children: PropTypes.node,
};

export default CheckoutEmbedModal;
